// API Endpoints configuration
export const API_CONFIG = {
  // Chat API - our backend (handles everything including branch data)
  CHAT_BASE: process.env.NODE_ENV === 'production' ? '' : 'http://localhost:10000',
};

export const getChatApiUrl = (endpoint) => {
  return `${API_CONFIG.CHAT_BASE}${endpoint}`;
};
